<template>
  <div class="footer__main-container">
    <div> User: {{ user && user.userable ? user.userable.name : '' }}</div>
    <div class="date-info"> Date: {{ $options.format(Date.now(), 'MM/dd/yyyy') }}</div>
  </div>
</template>

<script>
import { format } from 'date-fns'
export default {
  format,
  computed: {
    user() {
      return this.$store.state.user || {}
    }
  }
}
</script>

<style lang="scss" scoped>
  .footer__main-container {
    height: 40px;
    width: 100%;
    display: flex;
    align-items: center;
    background-color: rgb(75, 74, 74);
    padding: 0 20px;
    color: white;
    font-size: 10pt;
    justify-content: space-between;
    position: fixed;
    bottom: 0;
  }
</style>